import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signIn } from 'aws-amplify/auth';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const { isSignedIn, nextStep } = await signIn({ username: email, password });
      
      if (isSignedIn) {
        navigate('/dashboard');
      } else if (nextStep.signInStep === 'CONFIRM_SIGN_UP') {
        setError('아직 관리자의 승인이 진행되지 않았습니다. kmhak@ (김학성) 님께 Slack 문의 부탁드립니다. 감사합니다.');
      } else {
        setError('로그인을 완료할 수 없습니다. 관리자에게 문의해주세요.');
      }
    } catch (error) {
      // UserNotConfirmedException 처리
      if (error.name === 'UserNotConfirmedException') {
        setError('아직 관리자의 승인이 진행되지 않았습니다. kmhak@ (김학성) 님께 Slack 문의 부탁드립니다. 감사합니다.');
      } else if (error.message && error.message.includes('not confirmed')) {
        setError('아직 관리자의 승인이 진행되지 않았습니다. kmhak@ (김학성) 님께 Slack 문의 부탁드립니다. 감사합니다.');
      } else {
        setError(error.message || '로그인에 실패했습니다.');
      }
    }
  };

  return (
    <div className="auth-container">
      <h2>로그인</h2>
      <form onSubmit={handleSignIn}>
        <div className="form-group">
          <label>이메일</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="example@amazon.com"
          />
          <small className="email-notice">오직 @amazon.com 도메인만 허용됩니다</small>
        </div>
        <div className="form-group">
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="error">{error}</p>}
        <button type="submit">로그인</button>
      </form>

    </div>
  );
};

export default SignIn;
